import { ButtonBase, Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import classNames from 'classnames'
import React from 'react'
import { tokens } from '../../styles/tokens'

const useStyles = makeStyles((theme: Theme) => ({
  segment: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '7px 14px',
    borderRadius: '9px',
    whiteSpace: 'nowrap',
    fontFamily: 'inherit',
    color: tokens.color.neutral[500],
    transition: `background-color ${tokens.transition.fast}, color ${tokens.transition.fast}, box-shadow ${tokens.transition.base}`,
    '&:hover': {
      color: tokens.color.neutral[900],
      backgroundColor: 'rgba(255, 255, 255, 0.55)',
    },
  },
  selected: {
    backgroundColor: tokens.color.white,
    color: tokens.color.neutral[900],
    boxShadow: '0 1px 3px rgba(8, 38, 69, 0.12), 0 1px 1px rgba(8, 38, 69, 0.06)',
    '&:hover': {
      backgroundColor: tokens.color.white,
    },
    '& $label': {
      fontWeight: 600,
    },
    '& $count': {
      color: tokens.color.primary[700],
    },
  },
  dot: {
    width: '7px',
    height: '7px',
    borderRadius: tokens.radius.full,
    flexShrink: 0,
  },
  label: {
    fontSize: '0.8125rem',
    fontWeight: 500,
    lineHeight: 1,
  },
  count: {
    fontSize: '0.8125rem',
    fontWeight: 600,
    lineHeight: 1,
    fontVariantNumeric: 'tabular-nums',
    color: tokens.color.neutral[400],
  },
}))

// Track (šedá "kolejnice") pro skupinu segmentů — použití:
// <div className={segmentTrackClass}>...<ActiveOrdersTile/>...</div>
export const useSegmentTrackStyles = makeStyles((theme: Theme) => ({
  track: {
    display: 'inline-flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '6px',
    padding: '4px',
    backgroundColor: tokens.color.neutral[100],
    borderRadius: '12px',
    maxWidth: '100%',
    margin: 0,
    // Desktop: střed tracku zarovnat se středem první dlaždice v levém menu
    // (dlaždice ~62px vs track ~35px => +14px) a pevná mezera ke kartě filtrů.
    [theme.breakpoints.up('md')]: {
      marginTop: '14px',
      marginBottom: '16px',
    },
  },
}))

interface Props {
  label: React.ReactNode
  count: React.ReactNode
  selected?: boolean
  dot?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}

export const ActiveOrdersTile: React.FC<Props> = ({ label, count, selected = false, dot, onClick }) => {
  const classes = useStyles()
  return (
    <ButtonBase
      disableRipple
      onClick={onClick}
      className={classNames(classes.segment, selected && classes.selected)}
    >
      {dot && <span className={classes.dot} style={{ backgroundColor: dot }} />}
      <span className={classes.label}>{label}</span>
      <span className={classes.count}>{count}</span>
    </ButtonBase>
  )
}
